<div>
  <h1  class=" text-center mt-2"> Education MIS Report</h1>
  <div class="d-flex gap-2" *ngIf="!hideFilters">
    <mat-form-field appearance="outline">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date" />
        <input matEndDate [(ngModel)]="endDate" placeholder="End date" />
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-6">
      <mat-label>Select Centre</mat-label>
      <mat-select #selectElement [(ngModel)]="selectedCentreCode" multiple>
        <mat-select-trigger>
          <ng-container *ngIf="selectedCentreCode?.length > 0; else noneSelected">
            {{ getCentreName(selectedCentreCode[0]) }}
            <span *ngIf="selectedCentreCode.length > 1" class="additional-selection">
          + {{ selectedCentreCode.length - 1 }} more
        </span>
          </ng-container>
          <ng-template #noneSelected>Select Centre</ng-template>
        </mat-select-trigger>
        <app-select-all [matSelect]="selectElement"></app-select-all>
        <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">
          {{ c.centreName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-mini-fab color="accent" (click)="Search()" permission="MIS Report" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab color="accent" (click)="Clear()">
      <mat-icon>clear</mat-icon>
    </button>
    <div class="export-button m-l-10" matTooltip="XLSX"
         (click)="exportToExcel()" permission="MIS Report" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
      <img src="../../../../../assets/images/icons/xlsx.png" alt="" />
    </div>
  </div>
  <div class="table-wrapper">
  <table id="MisTable">
    <thead>
    <tr>
      <th >Non-Formal Education Intervention</th>
      <th *ngFor="let centre of mCentres" class="wrap-header">{{ centre.centreName }}</th>
      <th>Total</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td style="background:#F9FBE7">Rapport Building Session (A)</td>
      <ng-container *ngIf="allRapportBuildingSessionCountTotal  > 0; else noCentreDataG">
        <td *ngFor="let centreData of allRapportBuildingSessionCount">{{ centreData.sessionCountBySession || '-' }}</td>
      </ng-container>

      <ng-template #noCentreDataG>
        <td *ngFor="let centre of mCentres">-</td>
      </ng-template>

      <td class="total-column">{{ allRapportBuildingSessionCountTotal || 0 }}</td>
    </tr>
<!--    Baseline Assessment (B)-->
    <tr>
      <td style="background:#F9FBE7 ">Baseline Assessment (B)</td>
      <ng-container *ngIf="allBaselineAssessmentSessionCountTotal  > 0; else noCentreDataG">
        <td *ngFor="let centreData of allBaselineAssessmentSessionCount">{{ centreData.sessionCountBySession || '-' }}</td>
      </ng-container>

      <ng-template #noCentreDataG>
        <td *ngFor="let centre of mCentres">-</td>
      </ng-template>

      <td class="total-column">{{ allBaselineAssessmentSessionCountTotal || 0 }}</td>
    </tr>
    <!-- Individual Sessions by AL Teacher (C) with fallback -->
    <tr>
      <td style="background:#F9FBE7 ">Individual Sessions by AL Teacher (C)</td>
      <!-- Check if allCentreSessions has data -->
      <ng-container *ngIf="allIndividualSessionsByALTeacherTotal > 0; else noCentreData">
        <td *ngFor="let centreData of allIndividualSessionsByALTeacherCount">{{ centreData.sessionCountBySession  || '-' }}</td>
      </ng-container>

      <!-- Fallback row when no data is available in allCentreSessions -->
      <ng-template #noCentreData>
        <td *ngFor="let centre of mCentres">-</td>
      </ng-template>

      <td class="total-column">{{ allIndividualSessionsByALTeacherTotal || 0 }}</td>
    </tr>
    <!-- Individual Sessions done by Volunteers (D) -->
    <tr>
      <td style="background:#F9FBE7 ">Individual Sessions by Volunteers (D)</td>
      <ng-container *ngIf="allIndividualSessionsdoneVolunteersTotal > 0; else noCentreDataD">
        <td *ngFor="let centreData of allIndividualSessionsdoneVolunteersCount">
          {{ centreData.sessionCountBySession || '-' }}
        </td>
      </ng-container>
      <!-- Fallback template when no data for this center (0 sessions) -->
      <ng-template #noCentreDataD>
        <td *ngFor="let centre of mCentres">-</td>
      </ng-template>
      <!-- Display total count at the end -->
      <td class="total-column">{{ allIndividualSessionsdoneVolunteersTotal || 0 }}</td>
    </tr>
    <!--    Intermediate Test Conducted (E)-->
    <tr>
      <td style="background:#F9FBE7 ">Intermediate Test Conducted (E)</td>
      <ng-container *ngIf="allIntermediateAssessmentSessionCountTotal  > 0; else noCentreDataG">
        <td *ngFor="let centreData of allIntermediateAssessmentSessionCount">{{ centreData.sessionCountBySession || '-' }}</td>
      </ng-container>

      <ng-template #noCentreDataG>
        <td *ngFor="let centre of mCentres">-</td>
      </ng-template>

      <td class="total-column">{{ allIntermediateAssessmentSessionCountTotal || 0 }}</td>
    </tr>
    <!--    Discharge Test (F)-->
    <tr>
      <td style="background:#F9FBE7 ">Discharge Test (F)</td>
      <ng-container *ngIf="allDischargeTestSessionCountTotal > 0; else noCentreDataF">
        <td *ngFor="let centreData of allDischargeTestSessionCount">{{ centreData.sessionCountBySession || '-' }}</td>
      </ng-container>

      <ng-template #noCentreDataF>
        <td *ngFor="let centre of mCentres">-</td>
      </ng-template>

      <td class="total-column">{{ allDischargeTestSessionCountTotal || 0 }}</td>
    </tr>
    <!-- Group sessions by Teacher (G) with fallback -->
    <tr>
      <td style="background:#F9FBE7 ">Group Sessions by Teacher (G)</td>
      <ng-container *ngIf="allGroupSessionsTotal > 0; else noCentreDataG">
        <td *ngFor="let centreData of allGroupSessionsCount">{{ centreData.sessionCountBySession || '-' }}</td>
      </ng-container>

      <ng-template #noCentreDataG>
        <td *ngFor="let centre of mCentres">-</td>
      </ng-template>

      <td class="total-column">{{ allGroupSessionsTotal || 0 }}</td>
    </tr>
    <!-- Group sessions by Volunteer (H) with fallback -->
    <tr>
      <td style="background:#F9FBE7 ">Group Sessions by Volunteer (H)</td>
      <ng-container *ngIf="allGroupSessionsByVolunteerTotal > 0; else noCentreDataH">
        <td *ngFor="let centreData of allGroupSessionsByVolunteerCount">{{ centreData.sessionCountBySession || '-' }}</td>
      </ng-container>

      <ng-template #noCentreDataH>
        <td *ngFor="let centre of mCentres">-</td>
      </ng-template>

      <td class="total-column">{{ allGroupSessionsByVolunteerTotal || 0 }}</td>
    </tr>

    <!-- Total sessions (A+B+C+D+E+F+G+H+I) with fallback -->
    <tr>
      <td style="background:#F9FBE7 ">Total sessions (A+B+C+D+E+F+G+H+I)</td>
      <ng-container *ngIf="calculateCenterWiseTotalSessionSum().length > 0; else noCombinedTotals">
        <td *ngFor="let total of calculateCenterWiseTotalSessionSum()" style="font-weight: bold">{{ total || '-' }}</td>
      </ng-container>
      <ng-template #noCombinedTotals>
        <td *ngFor="let centre of mCentres">-</td>
      </ng-template>
      <td class="total-column">{{ calculateGrandTotal() || 0 }}</td>
    </tr>
    <!-- Child's average session done with fallback -->
    <tr>
      <td style="background:#F9FBE7 ">Child's average session done</td>
      <ng-container *ngIf="childAverages && childAverages.length > 0; else noAverageData">
        <td  *ngFor="let centreAverage of childAverages">
          <!-- Custom rounding logic -->
          <strong>{{ customRound(centreAverage) || '-' }}</strong>
        </td>
      </ng-container>
      <ng-template #noAverageData>
        <td *ngFor="let centre of mCentres"><strong>-</strong></td>
      </ng-template>
      <td class="total-column">{{ (totalAverage || 0).toFixed(0) }}</td>
    </tr>
    </tbody>
  </table>
  </div>

  <!-- Unaccounted Group Sessions Debug Table -->
<!--  <div *ngIf="unaccountedRawSessions.length > 0" class="table-wrapper" style="margin-top:24px">-->
<!--    <div style="display:flex; align-items:center; gap:12px; margin-bottom:8px">-->
<!--      <h3 style="color:#e65100; margin:0">-->
<!--        ⚠️ Unaccounted Group Sessions (Row I) — {{ unaccountedRawSessions.length }} records-->
<!--      </h3>-->
<!--      <div class="export-button" matTooltip="Download XLSX" (click)="exportUnaccountedToExcel()">-->
<!--        <img src="../../../../../assets/images/icons/xlsx.png" alt="Excel" />-->
<!--      </div>-->
<!--    </div>-->

<!--    &lt;!&ndash; Fix button &ndash;&gt;-->
<!--    <div style="margin-bottom:12px; display:flex; align-items:center; gap:16px; flex-wrap:wrap">-->
<!--      <button mat-raised-button color="warn"-->
<!--              [disabled]="fixingConductedBy"-->
<!--              (click)="fixGroupSessionsConductedBy()"-->
<!--              matTooltip="Sets conductedBy = 'By Volunteer' on ALL educationGroupTest docs where countType === 'bychildren'">-->
<!--        <mat-icon>build</mat-icon>-->
<!--        {{ fixingConductedBy ? 'Updating...' : 'Fix: Set conductedBy = By Volunteer (countType = bychildren)' }}-->
<!--      </button>-->
<!--      <span *ngIf="fixConductedByStatus"-->
<!--            [style.color]="fixConductedByStatus.startsWith('❌') ? 'red' : '#2e7d32'"-->
<!--            style="font-size:13px; font-weight:500">-->
<!--        {{ fixConductedByStatus }}-->
<!--      </span>-->
<!--    </div >-->
<!--    <table>-->
<!--      <thead>-->
<!--        <tr>-->
<!--          <th>#</th>-->
<!--          <th>Document ID</th>-->
<!--          <th>Session Date</th>-->
<!--          <th>Count Type</th>-->
<!--          <th>Conducted By</th>-->
<!--          <th>Volunteer Name</th>-->
<!--          <th>Centre Code</th>-->
<!--          <th>Submitted By</th>-->
<!--        </tr>-->
<!--      </thead>-->
<!--      <tbody>-->
<!--        <tr *ngFor="let s of unaccountedRawSessions; let i = index">-->
<!--          <td>{{ i + 1 }}</td>-->
<!--          <td style="font-size:11px; word-break:break-all">{{ s.id }}</td>-->
<!--          <td>{{ s.sessionDate?.toDate ? (s.sessionDate.toDate() | date:'dd/MM/yyyy') : s.sessionDate }}</td>-->
<!--          <td>{{ s.countType }}</td>-->
<!--          <td style="color:#e65100; font-weight:bold">{{ s.conductedBy }}</td>-->
<!--          <td>{{ s.volunteerName }}</td>-->
<!--          <td>{{ s.centreCode }}</td>-->
<!--          <td>{{ s.submittedBy }}</td>-->
<!--        </tr>-->
<!--      </tbody>-->
<!--    </table>-->
<!--  </div>-->

</div>
